module.exports = __webpack_public_path__ + "img/key.6d4323b9.svg";